/**
 * Pre-compiled de messages for DraggableList
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  emptyMessage: `Artikel hier ablegen`,
  removeButtonLabel: `Artikel entfernen`,
};
